import { Box } from '@mui/material'

import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'

import { SiteStockFlowTable } from './SiteStockFlow.Table'
import { useSiteStockFlow } from './SiteStockFlow.data'

export const SiteStockFlowView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state
  const { view_width, view_height } = useWindowSize()

  const { data: siteStockFlowData, isLoading } = useSiteStockFlow({
    projectId,
    scenarioId,
  })

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader title="Site Stock Flow" />
        <SiteStockFlowTable
          data={siteStockFlowData ?? []}
          isLoading={isLoading}
        />
      </Box>
    </Page>
  )
}
